export enum HwidMatchMode {
  Lax = "lax",
  Postfix = "postfix",
  Prefix = "prefix",
  Strict = "strict",
}
